import React, { useState, useEffect } from 'react';
import './AskCompany.css';
import close_popup from '../../../img/close_popup.svg'
import { send } from 'emailjs-com';

const useValidation = (value, validations) => {
    const [isEmpty, setEmpty] = useState(true);
    const [emailError, setEmailError] = useState(true);
    const [linkError, setLinkError] = useState(true);
    const [inputValid, setInputValid] = useState(false);

    useEffect(() => {
        for (const validation in validations) {
            switch (validation) {
                case 'isEmpty':
                    value ? setEmpty(false) : setEmpty(true);
                    break;
                default:
            }
        }
    }, [value, validations]);

    useEffect(() => {
        if (isEmpty) {
            setInputValid(false);
        } else {
            setInputValid(true);
        }

    }, [isEmpty])

    return {
        isEmpty
    }
}

const useInput = (initialValue, validations) => {
    const [value, setValue] = useState(initialValue);
    const [isDirty, setDirty] = useState(false);
    const valid = useValidation(value, validations);

    const onChange = (e) => {
        setValue(e.target.value);
    }

    const onBlur = (e) => {
        setDirty(true)
    }

    const resetField = () => {
        setValue('');
        setDirty(false);
    }

    return {
        value,
        onChange,
        resetField,
        onBlur,
        isDirty,
        ...valid
    }
}

const AskCompany = () => {
    const name = useInput('', { isEmpty: true });
    const decision_maker = useInput('', { isEmpty: true });
    const email = useInput('', { isEmpty: true });
    const eventLink = document.location.href;
    const event = document.title;
    const eventDate = document.querySelector('#eventDate') ? document.querySelector('#eventDate').textContent : '';;
    const eventImage = document.querySelector('meta[property="og:image"]').getAttribute('content');
    const [letterSucces, setLetterSucces] = useState('');
    const [textErr, setTextErr] = useState('');
    const [showPopup, setShowPopup] = useState(false);


    const data = {
        from_name: name.value,
        decision_maker: decision_maker.value,
        email: email.value,
        eventLink: eventLink,
        event: event,
        eventDate: eventDate,
        eventImage: eventImage,
    }

    const onSubmit = (evt) => {
        evt.preventDefault();
        send(
            'service_9tfsft6',
            'template_3f0m32t',
            data,
            'T8konufN4tNlYUdsh'
        )
            .then((response) => {
                setLetterSucces(true);
            })
            .catch((err) => {
                setLetterSucces(false);
                setTextErr(err);
            });
        setShowPopup(true);
        name.resetField();
        decision_maker.resetField();
        email.resetField();
    }

	return (
        <div className='AskCompany'>
            <div className='ticket_form_head'>
                <h4>Ask your company to pay for your ticket</h4>
                <p>
                    85% of all Full Access tickets bought by businesses for their
                    teams
                </p>
            </div>
            <div className='ticket_form_body'>
                <p>
                    We will send a secure email with the event PDF to the Decision
                    Maker in your company. Usually, it's your HR, Team Lead, or CEO
                    who makes these decisions
                </p>
                <form onSubmit={onSubmit}>
                    <input placeholder='Full name*' required onChange={e => name.onChange(e)} onBlur={e => name.onBlur(e)} className={`form1__input ${(name.isDirty && name.isEmpty) && 'error'}`} value={name.value} type="text" name="from_name" />
                    <input placeholder='Name of the decision maker*' required onChange={e => decision_maker.onChange(e)} onBlur={e => decision_maker.onBlur(e)} className={`form1__input ${(decision_maker.isDirty && decision_maker.isEmpty) && 'error'}`} value={decision_maker.value} type="text" name="decision_maker" />
                    <input placeholder='Email of the decision maker*' required onChange={e => email.onChange(e)} onBlur={e => name.onBlur(e)} className={`form1__input ${(email.isDirty && email.isEmpty) && 'error'}`} value={email.value} type="email" name="email" />
                    <button className='ticket_form_btn'>SEND SECURE REQUEST</button>
                </form>
                {
                (letterSucces === true || letterSucces === false) && showPopup === true && <div className='form_popup form_message green' onClick={() => setShowPopup(false)}>
                    <div className='form_popup-modal'>
                        <img src={close_popup} className="form_popup-close" onClick={() => setShowPopup(false)} />
                        <p className='p1'>{letterSucces === true ? 'The form has been sent.' : `The email you sent could not be delivered. Error: ${textErr}`}</p>
                    </div>
                </div>
                }
            </div>
        </div>
	);
};

export default AskCompany;
